if (typeof google != "undefined") {

	var countries = {
		be : [50.8549698, 4.3403708, 8],
		lu : [49.753173, 6.104104, 10],
		fr : [49.110477, 2.347867, 6],
		de : [51.053944, 10.240882, 6],
		it : [41.945073, 12.499890, 6],
		gb : [53.885430, -1.573667, 6],
		nl : [52.062138, 4.488655, 8],
		ch : [46.834588, 8.404644, 8]
	};
	
	var map;
	
	var datas = {};
	var markers = {};
	var allMarkersLoaded = false;
	
	var image = new google.maps.MarkerImage('/dist/img/map/marker.png');
	var gwindow = new google.maps.InfoWindow();
	
	var slugify = function(text) {
	  return text.toString().toLowerCase()
	    .replace(/\s+/g, '-')           // Replace spaces with -
	    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
	    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
	    .replace(/^-+/, '')             // Trim - from start of text
	    .replace(/-+$/, '');            // Trim - from end of text
	};
	
	var getCountryCoordinates = function(country){
		if( countries.hasOwnProperty(country) ) return countries[country];
		return countries[country];
	}
	
	var countryInfo = getCountryCoordinates( $('body').data('country') );
	
	var mapOptions = {
	  zoom: countryInfo[2],
	  center: new google.maps.LatLng(countryInfo[0],countryInfo[1]),
	  mapTypeId: google.maps.MapTypeId.ROADMAP,
	  streetViewControl: false,
	  zoomControlOptions: {
      	position: google.maps.ControlPosition.RIGHT_CENTER
      },
      streetViewControlOptions: {
      	position: google.maps.ControlPosition.RIGHT_CENTER
      } 
	};
	
	var openWindow = function(marker, data, onmap){
	    if( undefined === onmap ) onmap = 0;
	    
	    if( data.web.indexOf('http://') < 0 ) {
	        data.web = 'http://' + data.web;
	    }
	        
	    gwindow.close();
	    gwindow.setContent (
	            '<div class="google-tip" >' + 
	            '<h6>' + data.name + '</h6>' +
	            '<p>' + data.address + '<br>' + data.postal + ' ' + data.city.charAt(0).toUpperCase() + data.city.slice(1).toLowerCase() + '<br />' +
	            data.phone + '<br/>' +
	            //'<a href="' + data.web + '" target="_blank" >' + data.web.replace('http://', ' ') + '</a></p>' +
	            '<a href="https://www.stuv.com/' + $('html').attr('lang') + '/dealer-4153-' + data.client + '-' + slugify(data.name) + '" target="_blank" >' + $('.map').data('infotext') + '</a></p>' +
	            '</div>'
	    );
	    gwindow.open(map,marker);
	    
	    //$.ajax({url:'/ajax/track' , data: { id: data.shop, map:onmap }, type: "POST" });
	    //ga('send', 'event', 'Resellers', 'Click on ' + (onmap ? 'map' : 'list') , data.name);
	};
	
	var initialize = function(){
	    buildMap();
	    callShops();
	
	    setInterval(function(){
	        google.maps.event.trigger(map, 'resize');
	    }, 500);
	};
	
	var callShops = function(filter){
	    
	    if( null !== filter && undefined !== filter ) {
	        filter = '?filter=' + filter;
	    } else {
	        filter = '';
	    }
	    
	    $.getJSON('/' + $('html').attr('lang') + '-' + $('body').data('country') + '/map/json' + filter, {}, function(shops) {
	        
	        setMarkers(shops);
	    });
	};
	
	var setMarkers  = function(shops){
	    $.each(markers, function(){
	        this.setMap(null);
	    });
	
	    $.each(shops,function(){
	    
	        var marker = new google.maps.Marker({
	            position: new google.maps.LatLng(this.lat,this.lon), 
	            map: map,
	            icon: image,
	            title: this.name
	        });     
	        
	        markers[this.id] = marker;      
	        datas[this.id] = this;
	        
	        var data = this;
	        google.maps.event.addListener(marker, 'click', function() {
	            openWindow(marker, data, 1);
	        });
	        
	    });
	    
	    allMarkersLoaded = true;
	};
	
	
	var buildMap = function() {
	    map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
	};
	
	google.maps.event.addDomListener(window, 'load', initialize);
	
	function rad(x) {
	    return x * Math.PI/180;
	}
	
	function findClosestMaker( lat, lng ) {
	
	    var R = 6371; // radius of earth in km
	    
	    var distances = {};
	    var closest = -1;
	    
	    for( var id in markers ) {
	        
	        var marker = markers[id];
	        
	        var mlat = marker.position.lat();
	        var mlng = marker.position.lng();
	        
	        var dLat  = rad(mlat - lat);
	        var dLong = rad(mlng - lng);
	        
	        var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
	            Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
	            
	        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
	        
	        var d = R * c;
	        distances[id] = d;
	        
	        if ( closest == -1 || d < distances[closest] ) {
	            closest = id;
	        }
	    }
	
	    return markers[closest];
	}
	
	$('a[data-toggle=dealers]').click(function(){
	    navigator.geolocation.getCurrentPosition( function(position){
	        
	        /*map.panTo(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
	        map.setZoom(9);*/
	        
	        var loop = setInterval(function(){
	            if(allMarkersLoaded) {
	                clearInterval(loop);
	                var m = findClosestMaker(position.coords.latitude, position.coords.longitude);
	                map.setCenter(m.getPosition());
	//              map.setZoom(9);
	            }           
	        }, 300);
	                
	    }, function(){
	    } );
	});

}